import outAxios from '@/plugins/axios2'
import removeAcentos from '@/utils/removeAcentos'
import { createLogger } from 'vuex'

const utils = {
  data() {
    return {
      formatDateView: ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"],
      formatDateApi: ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm','YYYY-MM-DD'],
      formatsBr: ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY"],
      formatsEn: ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm", "YYYY-MM-DD"]
    }
  },
  methods: {
    buscaCepApi: function (cep) {
      return new Promise(async (resolve, reject) => {
        if (!cep) return
        cep = cep.replace(/-/g, "");
        delete outAxios.defaults.headers.common["Authorization"]
        await outAxios.get('https://viacep.com.br/ws/'+cep+'/json')
        .then(response => {
          var ret = {}
          ret.logradouro = null
          ret.bairro = null
          ret.localidade = null
          ret.uf = null
          if (response.data) {
            ret.logradouro = response.data.logradouro ? removeAcentos(response.data.logradouro.toUpperCase()) : null
            ret.bairro = response.data.bairro ? removeAcentos(response.data.bairro.toUpperCase()) : null
            ret.localidade = response.data.localidade ? removeAcentos(response.data.localidade.toUpperCase()) : null
            ret.uf = response.data.uf ? response.data.uf.toUpperCase() : null
          }
          resolve(ret)
        })
        .catch(e => {
          reject(e)
        })
        .finally(() => {
        })
      })
    },
    converteDataParaView(data) {
      if (!data) return data
      let test = this.$moment(data, this.formatDateApi, true)
      if (test.isValid() === false) return data
      return this.$moment(data, this.formatDateApi, true).format('DD/MM/YYYY')
    },

    converteDataParaApi(data) {
      if (!data) return null
      if (!this.$moment(data, this.formatsBr, true).isValid()) return data
      return this.$moment(data, this.formatsBr, true).format('YYYY-MM-DD')
    },

    converteDataHoraParaView(data) {
      if (!data) return data
      return this.$moment(data, 'YYYY-MM-DD HH:mm:ss', true).format('DD/MM/YYYY HH:mm:ss')
    },

    converteDataHoraParaApi(data) {
      if (!data) return null      
      if (this.$moment(data, this.formatsBr).isValid()) return this.$moment(data, this.formatsBr).format('YYYY-MM-DD HH:mm:ss')
      return data
    },

    dataValida(data) {
      if (!data) return true
      //this.$moment.isDate()
      var date = this.$moment(data, 'YYYY-MM-DD', true);
      return date.isValid()
    },

    dataHoraValida(data) {
      //let dataFormat = this.$moment(data).toString()
      return this.$moment(data, 'YYYY-MM-DD HH:mm:ss', true).isValid()
    },

    validaDateWithNow(data) {
      if (!this.dataHoraValida(data)) return false
      let dateNow = this.$moment(new Date(), true).subtract(1, 'minutes');
      data = this.$moment(data, 'YYYY-MM-DD HH:mm:ss')
      return dateNow > data ? false : true

    },

    digitoTecladoValido: function (keyCode) {
      
      var numeros = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57]
      var letras = [65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90]
      var numpad = [96, 97, 98, 99, 100, 101, 102, 103, 104, 105]

      var found = numeros.find( item => item === keyCode )
      if (found) return true

      found = letras.find( item => item === keyCode )
      if (found) return true

      found = numpad.find( item => item === keyCode )
      if (found) return true

      return false

    },

  }

}

export default utils;


/* Lista de keycode

backspace	8
tab	9
enter	13
shift	16
ctrl	17
alt	18
pause/break	19
caps lock	20
escape	27
page up	33
Space	32
page down	34
end	35
home	36
arrow left	37
arrow up	38
arrow right	39
arrow down	40
print screen	44
insert	45
delete	46
0	48
1	49
2	50
3	51
4	52
5	53
6	54
7	55
8	56
9	57
a	65
b	66
c	67
d	68
e	69
f	70
g	71
h	72
i	73
j	74
k	75
l	76
m	77
n	78
o	79
p	80
q	81
r	82
s	83
t	84
u	85
v	86
w	87
x	88
y	89
z	90
left window key	91
right window key	92
select key	93
numpad 0	96
numpad 1	97
numpad 2	98
numpad 3	99
numpad 4	100
numpad 5	101
numpad 6	102
numpad 7	103
numpad 8	104
numpad 9	105
multiply	106
add	107
subtract	109
decimal point	110
divide	111
f1	112
f2	113
f3	114
f4	115
f5	116
f6	117
f7	118
f8	119
f9	120
f10	121
f11	122
f12	123
num lock	144
scroll lock	145
My Computer (multimedia keyboard)	182
My Calculator (multimedia keyboard)	183
semi-colon	186
equal sign	187
comma	188
dash	189
period	190
forward slash	191
open bracket	219
back slash	220
close braket	221
single quote	222

*/


// WEBPACK FOOTER //
// ./src/mixins/utils.js